import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyNewRirekishoFormatData,
  provideNewRirekishoFormatData,
  type NewRirekishoExampleSentences
} from '@/composables/format-edit/useNewRirekishoFormatData'
import {
  provideNewRirekishoHistories,
  useNewRirekishoHistories
} from '@/composables/format-edit/useNewRirekishoHistories'
import NewRirekishoEduHistoryCard from '@/components/format-edit/new-rirekisho/NewRirekishoEduHistoryCard.vue'
import NewRirekishoJobHistoryCard from '@/components/format-edit/new-rirekisho/NewRirekishoJobHistoryCard.vue'
import NewRirekishoLicenseCard from '@/components/format-edit/new-rirekisho/NewRirekishoLicenseCard.vue'
import NewRirekishoReasonCard from '@/components/format-edit/new-rirekisho/NewRirekishoReasonCard.vue'
import NewRirekishoAiMyprCard from '@/components/format-edit/new-rirekisho/NewRirekishoAiMyprCard.vue'
import NewRirekishoOthersCard from '@/components/format-edit/new-rirekisho/NewRirekishoOthersCard.vue'
import NewRirekishoRequestsCard from '@/components/format-edit/new-rirekisho/NewRirekishoRequestsCard.vue'
import NewRirekishoCreateDateCard from '@/components/format-edit/new-rirekisho/NewRirekishoCreateDateCard.vue'
import CompletedOutputPanel from '@/components/format-edit/completed/CompletedOutputPanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  basicData: Record<string, unknown>
  formatId?: string
  previewFormat?: {
    errorMessages?: Record<string, string>
    optionItems?: Record<string, unknown>
  } | null
  currentCardId?: string
  exampleSentences?: NewRirekishoExampleSentences
};



const { formLib } = useHostServices()

const { formatData } = useFormatLocalData({
  saveName: 'rirekisho',
  saveOtherName: 'shokumukeirekisho',
  createEmpty: createEmptyNewRirekishoFormatData
})
provideNewRirekishoFormatData(formatData)

const histories = useNewRirekishoHistories(formatData)
provideNewRirekishoHistories(histories)

const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiPostEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

const optionItems = computed(() => {
  if (!props.previewFormat || !props.previewFormat.optionItems) return {}
  return props.previewFormat.optionItems
})

const getMode = computed(() => process.env.VUE_APP_MODE)

const textareaMinRows = computed(() => {
  if (props.formatId === 'rirekisho_job_new') return 10
  if (props.formatId === 'rirekisho_job_new_single') return 6
  return 3
})

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = formLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  formatData.registYagioffer = true
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})

expose({
  saveName: 'rirekisho',
  formatData,
  addEducationalHistory: histories.addEducationalHistory
})

return { __sfc: true,props, formLib, formatData, histories, mailPdfEnabled, downloadPdfEnabled, isSendYagiPostEnabled, isSendYagiEmailEnabled, previewErrors, optionItems, getMode, textareaMinRows, dataChanged, NewRirekishoEduHistoryCard, NewRirekishoJobHistoryCard, NewRirekishoLicenseCard, NewRirekishoReasonCard, NewRirekishoAiMyprCard, NewRirekishoOthersCard, NewRirekishoRequestsCard, NewRirekishoCreateDateCard, CompletedOutputPanel }
}

})